import uploadUserEvents from '../dao/functions/sync/upload-user-events';
import { FlowyGlobal } from '../flowy';
import { IRealmUserEvent, TUserEventCategory, TUserEventType } from '../types';
import { createUserEvent } from './analytics-functions';

interface IFlowyAnalytics {
  flowyGlobal: FlowyGlobal;
}

class FlowyAnalytics {
  private _global: FlowyGlobal;

  constructor({ flowyGlobal }: IFlowyAnalytics) {
    this._global = flowyGlobal;
  }

  public init = async () => {};

  /**
   * Save a user event to the database
   * @param event
   */
  public saveUserEvent = async (event: IRealmUserEvent) => {
    const database = this._global.getDatabase();

    if (database) {
      await database.set({
        type: 'userEvents',
        value: event,
      });
    }
  };

  /**
   * Create a user event and save it to the database
   *
   * @param {TUserEventCategory} category user event category
   * @param {TUserEventType} type user event type
   * @param {boolean} upload if true the event will be uploaded to the server
   * @returns
   */
  public createUserEvent = async ({
    category,
    type,
    upload,
  }: ICreateUserEventParams) => {
    await createUserEvent({
      category,
      type,
      context: { global: this._global },
    });

    if (upload === true) {
      await this.uploadUserEvents();
    }
  };

  /**
   * Upload user events to the server
   */
  public uploadUserEvents = async () => {
    const database = this._global.getDatabase();
    const apiUrl = this._global.getApiUrl();
    const user = await this._global.getPlatformInterface()?.getUser();

    if (database && apiUrl && user) {
      await uploadUserEvents({
        context: {
          apiUrl,
          database,
          user,
        },
      });
    }
  };
}

interface ICreateUserEventParams {
  category: TUserEventCategory;
  type: TUserEventType;
  upload?: boolean;
}

export default FlowyAnalytics;
